import { getCookieByName } from '../getCookieByName';
import { isWisePage } from '../isWisePage';
export const getVisitorId = () => {
    if (!isWisePage()) {
        return null;
    }
    return getCookieByName('gid');
};
